import { ChartStatus } from 'components/charts/types/chart-palette.type';
import { HealthStatus, HealthThresholds } from 'views/playground/features/data-lab/types/health-status.type';

// Mortality rate (%), shared by the severity bar chart and the embedded health column.
export const MORTALITY_THRESHOLDS: HealthThresholds = { watch: 2, critical: 8 };

// Cage utilization (%), shared by the utilization gauge and the embedded utilization column.
export const UTILIZATION_THRESHOLDS: HealthThresholds = { watch: 50, critical: 75 };

export const HEALTH_STATUS_COLOR: Record<HealthStatus, keyof ChartStatus> = {
  good: 'green',
  watch: 'amber',
  critical: 'red',
};

export const healthStatusFor = (value: number, thresholds: HealthThresholds): HealthStatus => {
  if (value < thresholds.watch) return 'good';
  if (value < thresholds.critical) return 'watch';
  return 'critical';
};
